import React, { ReactElement } from "react";
import { isRoundTable } from "../variant";
import SelectMenu from "./SelectMenu";

type LayoutName = "A" | "B";

/**
 * A drop-down for the personal layout. The caller switches the layout (and redraws) in onChange; other
 * players in the lobby keep their own layout.
 */
export default function LayoutMenu(props: {
  variant: "chip" | "field";
  onChange: (round: boolean) => void;
}): ReactElement {
  return (
    <SelectMenu<LayoutName>
      variant={props.variant}
      title="Layout"
      options={[
        { value: "A", label: "Layout A", hint: "Standard" },
        { value: "B", label: "Layout B", hint: "Round table" },
      ]}
      value={isRoundTable() ? "B" : "A"}
      onChange={(v) => props.onChange(v === "B")}
    />
  );
}
